<div class="p-d-flex p-flex-column" id="flex-container">
    <div class="p-d-flex p-ai-center">
        <button *ngIf="(headerText && canWrite) || pendingSignoff" id="pending-signoff-button" class="p-button-link"
                pButton (click)="pendingSignoff = !pendingSignoff" [label]="headerText">
        </button>

        <shift-indicator></shift-indicator>
    </div>

    <div id="enter-notes-content" class="p-mb-3" [hidden]="tableMaximized">
        <div *ngIf="remindersEnabled" [hidden]="reminderCount === 0">
            <p-accordion class="reminder-accordion">
                <p-accordionTab header="Reminders" [(selected)]="remindersMaximized">
                    <ng-template pTemplate="header">
                        <p-badge [value]="reminderCount.toString()"></p-badge>
                    </ng-template>
                    <reminder-ticker (remindersChange)="reminderCount = $event.length"></reminder-ticker>
                </p-accordionTab>
            </p-accordion>
        </div>
    </div>
    <div id="note-entry" [hidden]="!hasEnterNotesTemplateActive" *ngIf="canWrite">
        <fieldset class="note-entry-fieldset p-mt-2">
            <div class="p-grid p-nogutter">
                <div class="p-col-12 p-mb-2 p-mb-md-0 p-md-1 p-order-md-1 p-text-center">
                    <button pButton class="p-button-rounded p-button-outlined" [label]="(narrowScreenQuery | async) ? 'Pop out' : ''" icon="pi pi-external-link" title="Pop out to floating window" (click)="moveNoteEntryToPopout()"></button>
                </div>
                <div class="note-entry p-col-12 p-md-10 p-md-offset-1 p-order-md-0">
                    <ng-container (container)="enterNotesContainerReady($event)"></ng-container>
                </div>
            </div>
        </fieldset>
    </div>

    <div id="note-table">
        <notes-table [defaultColumnKeys]="tableSource.columnKeys"
                     [getPDFReportQueryParams]="tableSource.getPDFReportQueryParams"
                     [savedPreferencesKey]="tableSource.preferencesKey"
                     [(maximized)]="tableMaximized"
                     [showMaximizeButton]="reminderCount > 0 || (!readOnlyView && templateSet && canWrite)"
                     [lastUpdate]="tableSource.lastUpdate"
                     [loading]="tableSource.loading"
                     [notes]="tableSource.notes"
                     [notesMessage]="tableSource.notesMessage"
                     sortMode="multiple"
                     [turnoverFilter]="tableSource.turnoverFilter"
                     verticalViewNameField="updatedBy"
                     (afterViewInit)="tableSource.afterViewInit($event)"
                     (reportFilterChanged)="tableSource.onReportFilterChanged()"
                     (scrollPageReached)="tableSource.onScrollPageReached($event)"
                     (sortChanged)="tableSource.onSortChanged($event)"
                     (noteTimeClicked)="tableSource.onNoteTimeClicked($event)"
                     (timeframeFilterChanged)="tableSource.onTimeframeFilterChanged($event)"
                     (turnoverFilterChanged)="tableSource.onTurnoverFilterChanged($event)"
                     (onNoteAction)="tableSource.onNoteActionEvent($event)">
        </notes-table>
    </div>
</div>